import { render, staticRenderFns } from "./OrderDetailEmail.vue?vue&type=template&id=32a4306c&"
import script from "./OrderDetailEmail.vue?vue&type=script&lang=js&"
export * from "./OrderDetailEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports